import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ErrorCircleIcon } from '../../icons';
import { useTranslation } from 'react-i18next';

export type UiError = {
  name: string;
  message: string;
  params?: Record<string, unknown> | null | undefined;
};

export function LocalizedError({ error }: { error: UiError }) {
  const { t } = useTranslation('errors');

  return t(error.name, error.message, error.params ?? undefined);
}

export function ErrorListItem({ error }: { error: UiError | string | undefined | null }) {
  if (!error) {
    return null;
  }

  return (
    <ListItem sx={{ gap: '8px' }}>
      <ListItemIcon sx={{ minWidth: 'unset' }}>
        <ErrorCircleIcon color="secondary" />
      </ListItemIcon>
      <ListItemText sx={{ color: 'text.primary', whiteSpace: 'pre-wrap' }}>
        {typeof error === 'string' ? error : <LocalizedError error={error} />}
      </ListItemText>
    </ListItem>
  );
}
